

















import { Component, Prop, Watch } from 'vue-property-decorator';
import Mixin from '@/mixin';

@Component({
  name: 'VPasswordInput'
})
export default class VPasswordInput extends Mixin {
  @Prop({ required: true }) value?: string;
  @Prop({ required: false }) show?: boolean;
  @Prop({ required: false }) customStyle?: string;
  public text = this.value;
  public showPassword = this.show || false;

  // Reflect external value changes (e.g. an auto-generated password) into the input.
  @Watch('value')
  onValueChange(val?: string) {
    if (val !== this.text) {
      this.text = val;
    }
  }

  get icon() {
    return this.showPassword ? 'ic-visible' : 'ic-invisible';
  }
}
